import React from 'react';
import mapImage from '../../Assets/prishtina.png'; 
import "./MapSection.css"


const MapSection = () => {
  const googleMapsUrl = "https://maps.app.goo.gl/SakoD8SWtMTPxann6"; 

  const handleClick = () => {
    window.open(googleMapsUrl, '_blank');
  };

  return (
    <div className='mapcontainer'>
        
      <img
        src={mapImage}
        alt="Map"
        onClick={handleClick}
      />
    </div>
  );
};

export default MapSection;
